import { Component, OnInit, Input } from '@angular/core';
import moment from 'moment/moment';

@Component({
  selector: 'fgbcl-ticket-transfer-window-status-bar',
  templateUrl: './ticket-transfer-window-status-bar.component.html',
  styleUrls: ['./ticket-transfer-window-status-bar.component.scss'],
})
export class TicketTransferWindowStatusBarComponent implements OnInit {
  @Input() windowStartDate: Date;
  @Input() windowEndDate: Date;
  @Input() availableTransfers: boolean;

  constructor() {}

  ngOnInit() {}

  windowStatus(): 'windowClosed' | 'windowNotOpen' | 'windowOpen' | 'noAvailableTransfers' {
    if (this.availableTransfers === false) {
      return 'noAvailableTransfers';
    }

    if (moment.utc(this.windowEndDate).isBefore(moment.utc())) {
      return 'windowClosed';
    } else if (moment.utc(this.windowStartDate).isAfter(moment.utc())) {
      return 'windowNotOpen';
    } else {
      return 'windowOpen';
    }
  }
}
